import React from 'react';
import DropDown from '../dropdown';
import { useTextResources } from '../../../language';

const RoomStatusesDropDown = ({ ...props }) => {
  const text = useTextResources();
  const types = [
    {
      value: 'ShowOutOfUseRooms',
      text: text('OutOfUseRooms'),
    },
    {
      value: 'ShowRoomsToClean',
      text: text('RoomsToClean'),
    },
  ];
  return (
    <DropDown
      search={false}
      data={types}
      valueField='value'
      textField='text'
      selection
      clearable
      {...props}
    />
  );
};

export default RoomStatusesDropDown;
